import axios from "axios";

const createTag = (params) => axios.post("tags", params);

export { createTag };
